var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import { scaleBand } from "d3-scale";
import { range } from "d3-array";
import { Bar } from "./Bar.esm.js";
class DataSeries extends Component {
  render() {
    const {
      data,
      height,
      padding,
      xScale
    } = this.props;
    const yScale = scaleBand().domain(range(data.length)).range([0, height]).paddingInner(padding);
    return /* @__PURE__ */ jsx("g", { children: data.map((point, idx) => /* @__PURE__ */ jsx(
      Bar,
      {
        label: point.label,
        height: yScale.bandwidth(),
        width: Math.abs(xScale(0) - xScale(point.value)),
        x: 1,
        y: yScale(idx),
        fill: point.color
      },
      idx
    )) });
  }
}
__publicField(DataSeries, "propTypes", {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: PropTypes.array,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  width: PropTypes.number,
  height: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  offset: PropTypes.number,
  padding: PropTypes.number,
  xScale: PropTypes.func
});
__publicField(DataSeries, "defaultProps", {
  padding: 0.1
});
export {
  DataSeries as default
};
